import { render, staticRenderFns } from "./CompanyBox.vue?vue&type=template&id=5c614ce4&scoped=true"
import script from "./CompanyBox.vue?vue&type=script&lang=js"
export * from "./CompanyBox.vue?vue&type=script&lang=js"
import style0 from "./CompanyBox.vue?vue&type=style&index=0&id=5c614ce4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c614ce4",
  null
  
)

export default component.exports